module.exports = __webpack_public_path__ + "img/method-img.cccf73dd.png";